/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AdminGatewayPaymentDto = {
    id: string;
    createdAt: string;
    updatedAt: string;
    amount: number;
    reference: string;
    customerFullName?: string;
    customerPhone?: string;
    status: AdminGatewayPaymentDto.status;
    createdBy?: string;
    shopId?: string;
    shopName?: string;
    loanId?: string;
};
export namespace AdminGatewayPaymentDto {
    export enum status {
        PENDING = 'PENDING',
        COMPLETED = 'COMPLETED',
    }
}

